// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"3ff01049","777":"ff5d87b7"}[chunkId] + ".chunk.js";
};